// Error boundary — a render throw must NEVER leave a panel stuck on its
// loading card (the session-41 serial-date hang: an unguarded parse killed the
// re-render and "Loading booking…" stayed on screen forever). Catches any
// render/lifecycle error below it, reports server-side, and shows an
// actionable error card instead.
import { Component } from "preact";
import { reportError, SUPPORT_PHONE } from "../lib/errlog.js";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(err) {
    reportError(this.props.context || "render_boundary", err);
  }

  render() {
    if (this.state.failed) {
      return (
        <div class="admin-panel">
          <div class="surface status status-err">
            Something went wrong showing this page. Reload to try again — if it keeps failing, call or text Julie at {SUPPORT_PHONE}.
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
